// client/src/components/admin/advertiser/AdvertiserBizInfoEditModal.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

function AdvertiserBizInfoEditModal({ open, onClose, advertiser, onSuccess }) {
  const [bizRegNo, setBizRegNo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open && advertiser) {
      setBizRegNo(advertiser.bizRegNo || '');
      setError('');
    }
  }, [open, advertiser]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/advertiser/info/${advertiser.userId}/biz`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ bizRegNo: bizRegNo.trim() })
      });

      const data = await res.json();

      if (data.ok) {
        onSuccess();
        onClose();
      } else {
        setError(data.message || '사업자 정보 수정에 실패했습니다.');
      }
    } catch (err) {
      console.error('handleSubmit error:', err);
      setError('사업자 정보 수정 중 오류가 발생했습니다.');
    }
    setLoading(false);
  };

  if (!open) return null;

  return (
    <div className="advertiser-bizinfo-modal">
      <div className="advertiser-bizinfo-modal__content">
        <h2 className="advertiser-bizinfo-modal__title">
          사업자 등록번호 수정
        </h2>

        <form onSubmit={handleSubmit}>
          {/* 사업자 등록번호 입력 */}
          <div className="advertiser-bizinfo-modal__form-group">
            <label className="advertiser-bizinfo-modal__label">
              사업자 등록번호
            </label>
            <input
              type="text"
              value={bizRegNo}
              onChange={(e) => setBizRegNo(e.target.value)}
              className="advertiser-bizinfo-modal__input"
              placeholder="사업자 등록번호를 입력하세요 (빈 값 가능)"
            />
            <div className="advertiser-bizinfo-modal__hint">
              * 빈 값으로 저장하면 '미등록' 상태가 됩니다.
            </div>
          </div>

          {/* 안내 메시지 */}
          <div className="advertiser-bizinfo-modal__info">
            <strong>ℹ️ 안내</strong>
            <ul className="advertiser-bizinfo-modal__info-list">
              <li>사업자 등록번호는 자유롭게 입력할 수 있습니다.</li>
              <li>형식 검증 없이 저장됩니다.</li>
              <li>제한 조건 없이 언제든지 수정 가능합니다.</li>
            </ul>
          </div>

          {/* 에러 메시지 */}
          {error && (
            <div className="advertiser-bizinfo-modal__error">
              {error}
            </div>
          )}

          {/* 버튼 */}
          <div className="advertiser-bizinfo-modal__actions">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="advertiser-bizinfo-modal__button advertiser-bizinfo-modal__button--cancel"
            >
              취소
            </button>
            <button
              type="submit"
              disabled={loading}
              className="advertiser-bizinfo-modal__button advertiser-bizinfo-modal__button--submit"
            >
              {loading ? '저장 중...' : '저장'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdvertiserBizInfoEditModal;

